import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { tokenManager } from "../services/tokenManager";

/**
 * AppBridgeAuthInjector Component
 *
 * This component injects the Shopify App Bridge token getter function
 * into the token manager, which provides centralized access for axios interceptors
 * and Apollo Client middleware.
 *
 * This component should be rendered once in the app layout,
 * inside both AuthProvider and AppProvider.
 */
export function AppBridgeAuthInjector() {
  const { getToken } = useAuth();

  useEffect(() => {
    // Inject the token getter function into the token manager
    // This allows all API requests to automatically include the Shopify session token
    tokenManager.setTokenGetter(getToken);

    if (process.env.NODE_ENV === 'development') {
      console.log("[AppBridgeAuthInjector] Token manager initialized");
    }
  }, [getToken]);

  // This is a utility component with no UI
  return null;
}
